/**
 * src/shell/save/candidates.ts — 人才市场候选（外壳自有键）。
 *
 * 引擎 SaveBundle（以 web/src/gm 代码为准）不含 candidates——候选是纯外壳状态
 * （人事部简历架），招聘 = 候选出架 + 经端口写入 employees。
 */

import type { Employee } from '../../gm'
import { CANDIDATES_KEY } from './keys'
import type { CandidatesFile } from './seed'

export function readCandidates(): Employee[] {
  try {
    const raw = localStorage.getItem(CANDIDATES_KEY)
    if (!raw) return []
    return (JSON.parse(raw) as CandidatesFile).candidates
  } catch {
    return []
  }
}

export function writeCandidates(candidates: Employee[]): void {
  localStorage.setItem(CANDIDATES_KEY, JSON.stringify({ candidates } satisfies CandidatesFile))
}
